export default __webpack_public_path__ + "static/media/teaser_montage_06_1kbr3.79f7c6ed.mp4";